import qs from 'qs'

function isNumeric(str) {
  return /^\d+$/.test(str)
}

export default function useSearch(url, model) {
  const loading = ref(false)

  const searchModel = ref(Object.assign({}, model))
  const query = qs.parse(window.location.search.replace('?', ''))
  Object.keys(query).forEach((key) => {
    if (isNumeric(query[key])) {
      query[key] = Number(query[key])
    }
  })

  const pagination = reactive({
    current: query.page || 1,
    pageSize: query.size || 10,
    total: 0,
    showPageSize: true,
    showJumper: true,
    showTotal: true
  })

  Object.assign(searchModel.value, query)

  const eventHandler = (eventName, options = { page: 1, size: 10 }) => {
    switch (eventName) {
      case 'changePage':
        pagination.current = options.page
        break
      case 'changePageSize':
        pagination.pageSize = options.size
        break
      case 'reset':
        pagination.current = 1
        Object.assign(searchModel.value, model)
        break
      default:
        break
    }
    Object.assign(searchModel.value, {
      page: pagination.current,
      size: pagination.pageSize
    })
    queryData()
  }

  const queryData = async () => {
    loading.value = true
    router.get(
      url,
      { ...searchModel.value },
      {
        preserveState: true,
        preserveScroll: true,
        replace: true,
        only: ['rows', 'pagy'],
        onSuccess: (resp) => {
          pagination.total = resp.props.pagy?.count
        },
        onFinish: () => {
          loading.value = false
        }
      }
    )
  }

  const updatePagination = (pagy) => {
    pagination.total = pagy.count
  }

  return {
    loading,
    pagination,
    updatePagination,
    searchModel,
    queryData,
    eventHandler
  }
}
